import { routes } from "~/routes";

export const headers = {
  [routes.intro]: {
    title: "Intro",
  },
  [routes.termsAndConditions]: {
    title: "AGB",
    subtitle: "Allgemeine Geschäftsbedingungen",
  },
  [routes.faq]: {
    title: "F.A.Q.",
    subtitle: "Gerne beantworten wir deine Fragen!",
  },
  [routes.imprint]: {
    title: "Impressum",
    subtitle: "Unsere digitale Visitenkarte",
  },
  [routes.joinUs]: {
    title: "Komm ins Team!",
    subtitle: "Absolviere dein Praktikum oder Ref. bei LexMea",
  },
  [routes.privacyNotice]: {
    title: "Datenschutzhinweise",
    subtitle: "DS-GVO und mehr!",
  },
  [routes.schemas]: {
    title: "Schemata",
    subtitle: "Übersicht aller LexMea-Schemata.",
  },
  [routes.team]: {
    title: "Team",
    subtitle: "Lerne das LexMea-Team kennen!",
  },
  [routes.updates]: {
    title: "Updates",
    subtitle: "Neues für Dich auf LexMea",
  },
  [routes.vision]: {
    title: "Vision",
    subtitle: "Dein Jura in Zukunft",
  },
};
